import heroTextData from './components/FullScreenHeroWithLogoGrid/lang';
import alliesTextData from './components/Partners/lang';
import productTextData from './components/Product/lang';
import teamTextData from './components/Team/lang';
import testimonialsTextData from './components/Testimonials/lang';

const landingTextDataES = {
  ...heroTextData.es,
  ...alliesTextData.es,
  ...productTextData.es,
  ...teamTextData.es,
  ...testimonialsTextData.es
};
const landingTextDataEN = {
  ...heroTextData.en,
  ...alliesTextData.en,
  ...productTextData.en,
  ...teamTextData.en,
  ...testimonialsTextData.en
};

export { landingTextDataEN, landingTextDataES };
